export default "__VITE_ASSET__BJULNHED__"